module.exports = "/static/assets/cdb526cf25d15942e9db8cc2eb73c28b.png";